import { render, staticRenderFns } from "./MDACertificate.vue?vue&type=template&id=7e997cdb&"
import script from "./MDACertificate.vue?vue&type=script&lang=js&"
export * from "./MDACertificate.vue?vue&type=script&lang=js&"
import style0 from "./MDACertificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports